module.exports = {
  caller: 'lope_service',
  secretKey: 'Y$%^YHF3%^&lp0986Q2&K',
  pid: 'utjgh4765ufgmbjiyo',
  appId: 'com.lope.smartlife.miniprogram',
  appName: '诺谱生活',
  appVersion: '1.0.8',
  salt: 'L0%TG_OKHR@W92kP',
  isDebug: true
}



// WEBPACK FOOTER //
// ./src/lib/utils/config.js